import React, { useState } from 'react';
import EtarTaskPicker, { matchedEtarTasks, etarCoverageLabel } from './EtarTaskPicker';

export default function StatusEtarTaskLinks({ etar, requirements, onSave, disabled }) {
  const [draft, setDraft] = useState(null);
  const [feedback, setFeedback] = useState(null);
  const linkedIds = matchedEtarTasks(etar).map(task => task.id);
  const selectedIds = draft ?? linkedIds;
  const changed = [...selectedIds].sort().join(',') !== [...linkedIds].sort().join(',');
  const saving = feedback?.status === 'saving';
  const save = async () => {
    setFeedback({ status: 'saving', message: 'Saving task coverage...' });
    try {
      await onSave(etar.id, selectedIds);
      setDraft(null);
      setFeedback({ status: 'success', message: `Saved ${etarCoverageLabel({ matchedRequirements: selectedIds })}.` });
    } catch (error) {
      setFeedback({ status: 'error', message: error.response?.data?.message || error.message || 'Task coverage could not be saved.' });
    }
  };
  return <div>
    <div className="crystal-ball__etar-link">
      <EtarTaskPicker etarNumber={etar.etarNumber} requirements={requirements} selectedIds={selectedIds}
        disabled={disabled || saving} saved={feedback?.status === 'success'} onChange={ids => { setDraft(ids); setFeedback(null); }} />
      <button type="button" onClick={save} disabled={disabled || saving || !changed}>{saving ? 'Saving...' : 'Save links'}</button>
    </div>
    {feedback ? <span className={`crystal-ball__etar-link-feedback is-${feedback.status}`} role={feedback.status === 'error' ? 'alert' : 'status'}>{feedback.message}</span> : null}
  </div>;
}
